export const ignoredPatterns = [
  /akamai/, // matches CDN during live playback
  /snowplow/, // pageload and event analytics
  /litix/, // mux analytics
];

type ApmTransaction = {
  name: string;
  type: string;
};

type ApmPayload = {
  transactions?: ApmTransaction[];
  errors?: unknown[];
};

export const apmRumRemoveIgnored = (payload: unknown) => {
  assertPayload(payload);

  if (payload.transactions) {
    payload.transactions = payload.transactions.filter(
      (transaction) =>
        !ignoredPatterns.some((regex) => regex.test(transaction.name))
    );
  }

  return payload.transactions?.length || payload.errors?.length
    ? payload
    : false;
};

export const apmRumIdPlaceholders = (payload: unknown) => {
  assertPayload(payload);

  if (payload.transactions) {
    for (const transaction of payload.transactions) {
      transaction.name = transaction.name.replace(
        /\b(?:1-\d+|30-\d+|57-[\w-]+)\b/g,
        ':id'
      );
    }
  }

  return payload;
};

function assertPayload(payload: unknown): asserts payload is ApmPayload {
  if (typeof payload !== 'object' || !payload) {
    throw new Error('Payload is not an object');
  }
  if ('transactions' in payload && !Array.isArray(payload.transactions)) {
    throw new Error('Payload transactions is not an array');
  }
  if ('errors' in payload && !Array.isArray(payload.errors)) {
    throw new Error('Payload errors is not an array');
  }
}
